export const FOLDER_VIEW_DOMAIN = 'external/folder-view';
export const FOLDER_VIEW_DOMAIN_URL = `/${FOLDER_VIEW_DOMAIN}/*`;
export const FOLDER_VIEW_PAGE_TITLE = 'Folder View';

/** Deep link to a single account's derived folder tree. */
export const getFolderViewAccountPath = (accountId: number): string =>
  `/${FOLDER_VIEW_DOMAIN}/account/${accountId}`;
